import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initFacilitiesFunction() {
    (()=> {
        const sliderEls = document.querySelectorAll('.js-facilitiesSlider');
        sliderEls.forEach((el) => {
            new Swiper(el, {
                slidesPerView: 1,
                speed: 1000,
                delay: 3000,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                pagination: {
                    el: el.querySelector('.facilitiesSlider__nav__pagination') || el.querySelector('.facilitiesSlider__pagination'),
                    clickable: true,
                },
                navigation: {
                    enabled: true,
                    nextEl: el.querySelector('.facilitiesSlider__nav__btn--next'),
                    prevEl: el.querySelector('.facilitiesSlider__nav__btn--prev'),
                },
            });
        });
    })()
}